import React, { useState } from "react"
import { useSelector } from "react-redux"
import { RootState } from "../../../redux/reducers"
import FormButton from "../../form-components/form-button"
import loadable from "@loadable/component"
import { FiX } from "@react-icons/all-files/fi/FiX"
import SlidingDialog from "../../dialogs/sliding-dialog"
const OrderSummary = loadable(() => import("../../../page-components/checkout-components/order-summary"))

function CartWrapper({ children }: { children: React.ReactNode }) {


    const [cartView, setCartView] = useState<boolean>()
    const { orderValueWithTaxes, totalItems, loading } = useSelector((state: RootState) => state.cart)

    const toggleDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {

        if (
            event.type === "keydown" &&
            ((event as React.KeyboardEvent).key === "Tab" ||
                (event as React.KeyboardEvent).key === "Shift")
        ) {
            return
        }
        setCartView(!cartView)
    }

    return (
        <>
            <button id={"cart_dialog_button"} onClick={toggleDrawer} style={{ height: "100%" }}>
                {children}
            </button>

            <SlidingDialog className={"bg-background-default rounded-l-3xl"} open={cartView} onClose={() => {
                setCartView(false);
            }}>
                <div className={"flex items-center relative h-16 px-6 justify-between"} style={{ borderBottom: "0.5px solid rgba(100,50,50,0.2)" }}>
                    <h5 className={"font-display text-2xl font-semibold"}>Your Cart</h5>
                    <button className={"absolute h-full right-0 px-6"} onClick={toggleDrawer}>
                        <FiX size={18} />
                    </button>
                </div>
                <div className={"overflow-y-auto flex flex-1 flex-col"} style={{ overflowY: "auto" }}>
                    <div className={"relative px-6 py-4"} style={{ borderBottom: "0.5px solid rgba(100,50,50,0.2)" }}>
                        {
                            orderValueWithTaxes > 595 ?
                                <p className={"text-sm font-sans font-medium text-green-800"}>Congrats! You get free
                                    shipping.</p>
                                :
                                <p className={"text-sm font-sans font-medium text-gray-800"}>₹{596 - orderValueWithTaxes} away
                                    from free shipping!</p>
                        }
                        <div className={"w-full mt-3 relative"}>
                            <div className={"bg-primary-default rounded-full w-full"} style={{
                                height: "6px",
                                margin: "4px",
                                width: orderValueWithTaxes >= 595 ? "calc(100% - 8px)" : `${(100 - (595 - orderValueWithTaxes) / 5.49)}%`,
                                transition: ".3s",
                                transitionTimingFunction: "cubic-bezier(0.165, 0.84, 0.44, 1)"
                            }} />
                            <div className={"absolute border border-1 border-gray-500 rounded-full w-full"}
                                 style={{ height: "14px", top: "-4px" }} />
                        </div>
                    </div>
                    {totalItems === 0 &&
                        <div className={"flex flex-col items-center justify-center py-8"}>
                            <svg className={"opacity-20 fill-yellow-900 h-8"} viewBox={"0 0 11 16"} fill={"none"} xmlns={"http://www.w3.org/2000/svg"}>
                                <path d={"M10.5284 0.848L10.5464 0.866V3.818L10.5284 3.836C10.1204 3.596 9.6464 3.35 9.1064 3.098C8.5784 2.846 8.1164 2.678 7.7204 2.594C8.1404 2.906 8.4584 3.308 8.6744 3.8C8.9024 4.28 9.0164 4.814 9.0164 5.402C9.0164 5.906 8.9264 6.38 8.7464 6.824C8.5664 7.256 8.3024 7.634 7.9544 7.958C7.6064 8.27 7.1804 8.516 6.6764 8.696C6.1844 8.876 5.6384 8.966 5.0384 8.966C4.0424 8.966 3.1724 8.72 2.4284 8.228C2.3564 8.612 2.3984 8.954 2.5544 9.254C2.7224 9.542 2.9744 9.74 3.3104 9.848C3.6464 9.956 4.0004 10.01 4.3724 10.01H6.4424C7.5104 10.01 8.3144 10.19 8.8544 10.55C9.3944 10.898 9.6644 11.456 9.6644 12.224C9.6644 12.728 9.5324 13.19 9.2684 13.61C9.0044 14.03 8.6264 14.384 8.1344 14.672C7.6424 14.972 7.0484 15.2 6.3524 15.356C5.6684 15.524 4.9244 15.608 4.1204 15.608C1.4924 15.608 0.178398 15.05 0.178398 13.934C0.178398 13.67 0.280398 13.418 0.484398 13.178C0.700398 12.95 0.994398 12.764 1.3664 12.62C1.1864 12.44 1.0424 12.206 0.934398 11.918C0.838398 11.642 0.790398 11.348 0.790398 11.036C0.790398 10.544 0.904398 10.064 1.1324 9.596C1.3724 9.128 1.7504 8.63 2.2664 8.102C1.8584 7.79 1.5404 7.4 1.3124 6.932C1.0844 6.464 0.970398 5.948 0.970398 5.384C0.970398 4.892 1.0604 4.43 1.2404 3.998C1.4324 3.566 1.7024 3.188 2.0504 2.864C2.4104 2.528 2.8484 2.27 3.3644 2.09C3.8924 1.91 4.4684 1.82 5.0924 1.82C5.5364 1.82 5.9684 1.874 6.3884 1.982C6.8204 2.09 7.1864 2.24 7.4864 2.432L10.5284 0.848ZM6.3524 8.444C6.5564 8.444 6.7184 8.378 6.8384 8.246C6.9704 8.102 7.0364 7.904 7.0364 7.652C7.0364 7.04 6.6764 6.092 5.9564 4.808C5.5004 4.004 5.0924 3.386 4.7324 2.954C4.3724 2.522 4.0304 2.306 3.7064 2.306C3.5144 2.306 3.3464 2.378 3.2024 2.522C3.0704 2.666 3.0044 2.858 3.0044 3.098C3.0044 3.662 3.3644 4.61 4.0844 5.942C4.9844 7.61 5.7404 8.444 6.3524 8.444ZM3.7784 13.358C2.7464 13.358 1.9784 13.142 1.4744 12.71C1.6784 13.514 2.1104 14.12 2.7704 14.528C3.4304 14.948 4.2344 15.158 5.1824 15.158C5.8664 15.158 6.4484 15.044 6.9284 14.816C7.4204 14.588 7.6664 14.312 7.6664 13.988C7.6664 13.568 7.0184 13.358 5.7224 13.358H3.7784Z"} fill={"inherit"}/>
                            </svg>
                            <p  className={"font-sans font-medium text-sm opacity-50 mt-3"}>Your cart is empty</p>
                        </div>
                    }
                    <div  className={"p-6"}>
                        {totalItems !== 0 &&
                            <OrderSummary />
                        }
                    </div>
                </div>
                {totalItems !== 0 &&
                    <div className={"flex flex-col py-5 px-6 flex-shrink-0"}
                         style={{ borderTop: "0.5px solid rgba(100,50,50,0.2)" }}
                    >
                        <FormButton
                            to={"/checkout"}
                            onClick={() => {
                                setCartView(false)
                            }}
                        >
                            Checkout
                        </FormButton>
                    </div>
                }
            </SlidingDialog>
        </>
    )
}

export default CartWrapper